import React from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Constants } from '../utils';
import { RootState } from 'reducers';
import Menu from 'screens/menu/menu';

const _Route = (props: any) => {
	const history = useHistory();
	// const permissions = props.user?.permissions.map((i: any) => i.code);

	const permissions: any = [];

	if (!props.user && (props.auth || props.admin || props.client)) {
		return <Redirect to="/auth/login" />
	}
	else if (props.user && props.client && props.user.level_id != Constants.LEVELS.SELLER) {
		return <Redirect to="/profile" />
	}
	else if (props.user && props.admin && props.user.level_id == Constants.LEVELS.SELLER) {
		return <Redirect to="/profile" />
	}
	else if (props.user && props.admin && props.user.level_id == Constants.LEVELS.MODERATOR && props.permission && permissions.indexOf(props.permission) == -1) {
		return <Redirect to="/profile" />
	}
	else if (props.user && props.noAuth) {
		return <Redirect to="/profile" />
	}
	if (props.user && (props.auth || props.admin || props.client)) {
		return (
			<Menu history={ history }>
				<Route { ...props } />
			</Menu>
		)
	}
	else {
		return (
			// <Menu history={ history }>
			// 	<Route { ...props } />
			// </Menu>
		<Route { ...props } />
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(_Route);